import { handleActions } from 'redux-actions'
import {
  appInitSuccess,
  appInitError,
  appSetDomain,
  appSetPDV
} from './actions'
import { bookingError } from '../booking/actions'

const getDefaultState = () => ({
  domain: null,
  pdvID: null,
  isInitialized: false,
  initError: null,
  bookingError: null
})

export const reducer = handleActions(
  {
    [appSetDomain]: (state, { payload }) => ({ ...state, domain: payload }),
    [appSetPDV]: (state, { payload }) => ({ ...state, pdvID: payload }),
    [appInitSuccess]: state => ({ ...state, isInitialized: true }),
    [appInitError]: (state, { payload }) => ({ ...state, initError: payload }),
    [bookingError]: (state, { payload }) => ({
      ...state,
      bookingError: payload
    })
  },
  getDefaultState()
)
